import {
  isIntervalISODate,
  mapIsoDateToUTCAfternoon,
} from '@epicuro-next/utilities';
import { createSelector } from '@ngrx/store';

import { selectCachedState } from './business/config-strip-business.selectors';

/**
 * Returns cached delivery periods, for example, when user switched onto
 * another product, we want to save his delivery periods he already used
 * previously
 *
 * To make sure that user's cache matches current UTC afternoon agreement it's converted additionally
 */
export const selectCachedDeliveryPeriods = createSelector(
  selectCachedState,
  (cachedState) =>
    (cachedState.selectedDeliveryPeriods ?? []).map(mapIsoDateToUTCAfternoon),
);
export const selectCachedSelectedDeliveryPeriod = createSelector(
  selectCachedState,
  (cachedState) =>
    cachedState.lastSelectedDate
      ? mapIsoDateToUTCAfternoon(cachedState.lastSelectedDate)
      : null,
);
export const selectFutureCachedDeliveryDates = createSelector(
  selectCachedDeliveryPeriods,
  (cachedDates) =>
    cachedDates.filter((date: string) => !isIntervalISODate(date)),
);
